// extracted by mini-css-extract-plugin
export default {"wrapper":"Shop_wrapper__0a8zU","container":"Shop_container__Rufq5"};